import { Component, OnInit, OnDestroy } from '@angular/core';
import { PatientService } from 'src/app/services/patient.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { STORAGE_ASSETS_LINK, URLS } from 'src/app/constant/constant';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { LanguageService } from 'src/app/services/language.service'; // Import LanguageService
import { Subscription } from 'rxjs';

class consultations {
  consultation_type?: {
    consultation_image?: string;
    consultation_name: string;
  }
  consultation_name?: string;
  amount?: string;
  consultation_type_id?: number;
}


class commonissue {
  id: number;
  title: string;
  health_issue_image: string;
  consultation_type: consultations
}
@Component({
  selector: 'app-ad-landing-page',
  templateUrl: './ad-landing-page.component.html',
  styleUrls: ['./ad-landing-page.component.css']
})
export class AdLandingPageComponent implements OnInit, OnDestroy {

  commonissues: commonissue[] = [];
  storage_link = STORAGE_ASSETS_LINK;
  return_url: string = "";
  slug: string = "";
  is_uk_country: boolean = false;

  languageOptions: { code: string, name: string }[] = [
    { code: 'en', name: 'English' },
    { code: 'hi', name: 'Hindi' },
    { code: 'fr', name: 'French' },
    { code: 'ar', name: 'Arabic'},
    { code: 'es', name: 'Spanish' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'de', name: 'German' },
    { code: 'mr', name: 'Marathi' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'te', name: 'Telugu' },
    { code: 'ta', name: 'Tamil' },
    { code: 'bn', name: 'Bengali' },
    { code: 'ur', name: 'Urdu' },
    { code: 'pa', name: 'Punjabi' },
    { code: 'kn', name: 'Kannada' },
    { code: 'or', name: 'Oriya' },
    { code: 'ne', name: 'Nepali' }
  ];
  selectedLanguage: string = 'en'; // Default language

  navigationSubscription: Subscription;

  constructor(private readonly patientService: PatientService,
    private readonly jsonDataService: JsonDataService,
    public readonly router: Router,
    private utilitiesService: UtilitiesService,
    private readonly translateService: GoogleTranslateService,
    private readonly providerstateService: ProviderStateService,
    private readonly languageService: LanguageService
  ) { }

  async ngOnInit(): Promise<void> {
    this.slug = this.providerstateService.getProviderSlug();
    if (URLS.IS_UK) {
      this.is_uk_country = true;
    }
    this.getCommonHealthIssues();


    this.navigationSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(async () => {
        this.getCommonHealthIssues();
      });
    this.initializeLanguage();
  }



  async getCommonHealthIssues() {
    await this.patientService
      .getConsultationAndCommonHealthIssueLandingData()
      .toPromise()
      .then((result) => {
        if (result.success) {
          this.commonissues = result.data.common_health_issues;
        }
      }).catch(error => {
        console.log(error);
      });
  }

  responsiveOptions = [
    {
      breakpoint: '2560px',
      numVisible: 4,
      numScroll: 1,
    },
    {
      breakpoint: '1440px',
      numVisible: 4,
      numScroll: 1,
    },
    {
      breakpoint: '1024px',
      numVisible: 4,
      numScroll: 1,
    },
    {
      breakpoint: '768px',
      numVisible: 2,
      numScroll: 1,
    },
    {
      breakpoint: '560px',
      numVisible: 1,
      numScroll: 1,
    },
  ];
  gotoconsultnow() {
    this.router.navigate(['/' + this.slug + '/user/login/patient'], { queryParams: { return_url: "patient/consultdoctor" } });
  }
  gotomembership() {
    this.router.navigate(['/' + this.slug + '/user/login/patient'], { queryParams: { return_url: "patient/packages" } });
  }
  gotodiet() {
    this.router.navigate(['/' + this.slug + '/user/login/patient'], { queryParams: { return_url: "patient/nutrition-and-health" } });
  }
  consultNow(issueId: string): void {
    this.router.navigate(['/' + this.slug + '/consult-doctor'], {
      queryParams: { common_health_id: issueId }
    });
  }
  async openLink(base_url_name: string, link: string, target: string): Promise<void> {
    await this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
  }
  async translatePage(event: Event) {
    const selectedLangCode = (event.target as HTMLSelectElement).value;
    this.selectedLanguage = selectedLangCode; // Update selected language
    localStorage.setItem('selectedLanguageClient', selectedLangCode); // Save to localStorage
    this.translateService.setGoogleTranslateLanguage(selectedLangCode);
    this.languageService.setLanguage(selectedLangCode);

    // Update notranslate class based on the selected language
    if (selectedLangCode === 'en') {
      document.body.classList.add('notranslate');
    } else {
      document.body.classList.remove('notranslate');
    }
  }

  initializeLanguage() {
    const savedLanguage = localStorage.getItem('selectedLanguageClient') || 'en';
    this.selectedLanguage = savedLanguage;
    this.translateService.setGoogleTranslateLanguage(savedLanguage);

    // Update notranslate class based on the saved language
    if (savedLanguage === 'en') {
      document.body.classList.add('notranslate');
    } else {
      document.body.classList.remove('notranslate');
    }
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

}

